import { forwardRef } from 'react';
import { _renderCurrency } from './number';
import { handleNegativeValue } from './handleNegativeValue';

export const CurrencyInput = forwardRef(
  ({ value = 0, onChange, className, allowNegative = true, inputRef, ...props }, ref) => {
    const handleChange = (e) => {
      let rawText = e.target.value;
      let numberText = rawText.replace(/\D/g, '');
      let result = numberText;

      if (allowNegative) {
        result = handleNegativeValue(rawText, numberText);
      }
      if (result === '') {
        onChange?.('');
        return;
      }
      onChange?.(Number(result));
    };

    const handleMergedRef = (node) => {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
      if (typeof inputRef === 'function') {
        inputRef(node);
      } else if (inputRef) {
        inputRef.current = node;
      }
    };

    const displayValue = value === '' || value === null || value === undefined ? '' : _renderCurrency(value);

    return (
      <div>
        <input
          ref={handleMergedRef}
          className={`${className}`}
          autoComplete="off"
          inputMode="numeric"
          value={displayValue}
          onChange={handleChange}
          {...props}
        />
        <input hidden value={value ?? ''} onChange={() => {}} />
      </div>
    );
  }
);

CurrencyInput.displayName = 'CurrencyInput';
